import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkIntegration_Keys } from '@/common/api/types/workIntegrations';
import { AdoBoxIcon } from './AdoBoxIcon';
import { JiraBoxIcon } from './JiraBoxIcon';

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
  label?: string;
};

const ICON_BY_SOURCE: Record<WorkIntegration_Keys, ComponentType<IconProps>> = {
  [WorkIntegration_Keys.JIRA]: JiraBoxIcon,
  [WorkIntegration_Keys.ADO]: AdoBoxIcon,
};

type SourceSystemIconProps = {
  width?: number;
  height?: number;
  className?: string;
  sourceSystemType: WorkIntegration_Keys;
};

export const SourceSystemIcon = ({ sourceSystemType, ...props }: SourceSystemIconProps) => {
  const { t } = useTranslation();
  const Icon = ICON_BY_SOURCE[sourceSystemType];
  const label = t(($) => $.common.settings['work-integrations'].sourceSystemName[sourceSystemType]);
  return <Icon {...props} label={label} />;
};
